import { types } from 'mobx-state-tree';

import {
    JobStatusValues,
    YearsWithActiveInsuranceValues,
    DamageClaim,
    CancelRefusalClaim,
} from '../definitions/InsCommon';
import { Contact } from '../definitions/Common';


const OccupantModel = Contact
    .named('Occupant')
    .props({
        // dateOfBirth is currently stored as a string
        //  which is incompatible with dob on the Contact 
        //  model. This will be deprecated in the next
        //  document version (V9)
        dateOfBirth: types.maybeNull(types.string),
        jobStatus: types.maybeNull(types.enumeration(
            Object.values(JobStatusValues),
        )),
        currentlyInsured: types.maybeNull(types.boolean),
        yearsWithActiveInsurance: types.maybeNull(
            types.enumeration(Object.values(YearsWithActiveInsuranceValues)),
        ),
        everInsured: types.maybeNull(types.boolean),
        policyStartDate: types.maybeNull(types.string),
        anyClaims: types.maybeNull(types.boolean),
        damageClaims: types.array(DamageClaim),
        cancelRefusalClaims: types.array(CancelRefusalClaim),
    })
    .views(self => ({
        get isValid() {
            return self.firstName != null
            && self.lastName != null
            && self.dateOfBirth != null
            && self.jobStatus != null
            && self.currentlyInsured != null
            && (self.currentlyInsured === true
                ? self.yearsWithActiveInsurance != null
                : true)
            && self.policyStartDate != null;
        },
    }));

export default OccupantModel;